import * as RadixToast from "@radix-ui/react-toast";
import clsx from "clsx";
import { Text } from "@repo/ui/text";
import classes from "./toast.module.css";

export type ToastVariant = "default" | "error" | "success" | "info";

export type ToastProps = {
  title?: string;
  message: React.ReactNode;
  variant?: ToastVariant;
  open?: boolean;
  duration?: number;
  icon?: React.ReactNode;
  closeIcon?: React.ReactNode;
  onClose?: () => void;
  toastTitle?: string;
  toastMessage?: string;
  role?: "status" | "alert";
  dismissLabel?: string;
};

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <RadixToast.Provider swipeDirection="right">{children}</RadixToast.Provider>
  );
};

export const ToastViewport = () => {
  return <RadixToast.Viewport className={classes.viewport} />;
};

export const Toast = ({
  title,
  message,
  variant = "default",
  open = true,
  duration = 3000,
  closeIcon,
  onClose,
  toastTitle,
  toastMessage,
  role,
  dismissLabel,
}: ToastProps) => {
  const ariaRole = role ?? (variant === "error" ? "alert" : "status");

  return (
    <>
      <RadixToast.Root
        className={clsx(classes.root, classes[variant])}
        open={open}
        duration={duration}
        role={ariaRole}
        onOpenChange={(isOpen) => {
          if (!isOpen && onClose) onClose();
        }}
      >
        <div className={classes.content}>
          <div className={classes.text}>
            {title && (
              <Text className={clsx(classes.title, toastTitle)}>{title}</Text>
            )}
            <Text className={clsx(classes.message, toastMessage)}>
              {message}
            </Text>
          </div>
          {closeIcon && (
            <div className={classes.closeButtonContainer}>
              <RadixToast.Close
                className={classes.dismiss}
                aria-label={dismissLabel}
              >
                {closeIcon}
              </RadixToast.Close>
            </div>
          )}
        </div>
      </RadixToast.Root>
    </>
  );
};
